import { Component } from "minecs";
import { BaseTrigger } from "./BaseTrigger";

@Component()
export class DeathTrigger extends BaseTrigger {}
